import { useContext } from 'react';
import { NotificationsContext } from '../../../../../providers/NotificationsProvider';
import { useTranslation } from '../../../../../hooks/useTranslation';
import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    alert: {
      margin: '5px 1em',
      '& > .MuiAlert-message > p': {
        margin: 0,
      },
    },
  }),
);

export function useErrorNotification() {
  const notificationContext = useContext(NotificationsContext);
  const { t } = useTranslation();
  const classes = useStyles();

  const setErrorNotification = () => {
    notificationContext.setState({
      isOpen: true,
      message: t('GENERIC_ERROR_NOTIFICATION_MESSAGE_BODY'),
      severity: 'error',
      alertStyle: classes.alert,
    });

    typeof window !== 'undefined' && window.scrollTo(0, 0);
  };

  return { setErrorNotification };
}
